// extracted by mini-css-extract-plugin
export default {"wrap":"nI-z","subtitle":"oI-z","contentWrap":"pI-z","imgWrap":"qI-z","heading":"rI-z","copy":"sI-z"};